(() => {
 const media=matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
 const selector='a[href],button:not([disabled]):not([aria-disabled="true"]),summary';
 function setup(root=document){
  if(!media.matches)return;
  root.querySelectorAll(selector).forEach(el=>{
   if(el.classList.contains('bm-hover-target')||el.closest('.section-header,summary a')||el.matches('.skip-to-content-link,.visually-hidden'))return;
   const rect=el.getBoundingClientRect();
   if(!rect.width||!rect.height)return;
   el.classList.add('bm-hover-target');
   if(getComputedStyle(el).position==='static')el.classList.add('bm-hover-position');
   const light=document.createElement('span');light.className='bm-hover-light';light.setAttribute('aria-hidden','true');el.append(light);
   el.addEventListener('pointermove',event=>{if(!media.matches)return;const r=el.getBoundingClientRect();light.style.setProperty('--bm-x',`${event.clientX-r.left}px`);light.style.setProperty('--bm-y',`${event.clientY-r.top}px`);},{passive:true});
  });
 }
 setup();
 document.addEventListener('shopify:section:load',event=>setup(event.target));
 document.addEventListener('pointerover',event=>{if(media.matches && event.target.closest?.(selector))setup();},{passive:true});
 media.addEventListener('change',()=>setup());
})();
